(() => {
  const script = document.currentScript;
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.furcoInitialized) return;
  main.dataset.furcoInitialized = 'true';
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hero = main.querySelector('.hero');
  let observer;
  let button;
  let paused = preference.matches;
  try { paused = paused || sessionStorage.getItem('furco-motion') === 'paused'; } catch {}
  const revealAll = () => main.querySelectorAll('.furco-reveal').forEach(el => el.classList.add('furco-visible'));
  const update = () => {
    document.body.dataset.furcoMotion = paused || preference.matches ? 'paused' : 'on';
    if (button) {
      button.textContent = paused || preference.matches ? script.dataset.play : script.dataset.pause;
      button.setAttribute('aria-pressed', String(paused || preference.matches));
    }
    if (paused || preference.matches) revealAll();
  };
  if (hero && !preference.matches) {
    button = document.createElement('button');
    button.type = 'button';
    button.className = 'furco-motion-toggle';
    button.addEventListener('click', () => {
      paused = !paused;
      try { sessionStorage.setItem('furco-motion', paused ? 'paused' : 'on'); } catch {}
      update();
    });
    hero.querySelector('.hero__container').append(button);
    const ticker = document.createElement('div');
    ticker.className = 'furco-ticker';
    ticker.setAttribute('aria-hidden', 'true');
    const track = document.createElement('div');
    track.className = 'furco-ticker-track';
    for (let i = 0; i < 4; i++) {
      const line = document.createElement('span');
      line.textContent = script.dataset.ticker;
      track.append(line);
    }
    ticker.append(track);
    hero.closest('.shopify-section').after(ticker);
  }
  update();
  if ('IntersectionObserver' in window && !paused && !preference.matches) {
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('furco-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px 45px 0px' });
    main.querySelectorAll('product-card, .media-with-content .media-block, .media-with-content__content').forEach((el, i) => {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('furco-reveal');
      el.style.setProperty('--furco-reveal-delay', String((i % 3) * 80) + 'ms');
      observer.observe(el);
      el.addEventListener('focusin', () => el.classList.add('furco-visible'));
    });
  }
  preference.addEventListener('change', () => {
    if (preference.matches) { paused = true; observer?.disconnect(); }
    update();
  });
  document.addEventListener('shopify:section:load', revealAll);
})();
